import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import cognitoAuth from './cognito'
import router from './router'
import {PaginationPlugin,BCollapse,VBToggle,BTooltip,BButton,BToast,BTabs,BTab,VBTooltip } from 'bootstrap-vue'
import Bootstrap from 'bootstrap'
import '@/assets/vendor/@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import '@/assets/css/all.css';
import Chart from "chart.js";
import 'chartjs-plugin-labels';
import VueSimpleAlert from "vue-simple-alert";
import Multiselect from 'vue-multiselect'
import VueCurrencyInput from 'vue-currency-input'
import axios from 'axios';
import JQuery from "jquery";
import moment  from "moment";
import moment_timezone from 'moment-timezone'
import appMessages from "@/appMessages";
import Vue2Filters from 'vue2-filters';
import Notifications from 'vue-notification'
import firebaseMessaging from './firebase'

import VuePhoneNumberInput from 'vue-phone-country-code';
import 'vue-phone-country-code/dist/vue-phone-country-code.css';
import ToggleButton from 'vue-js-toggle-button';
import VueQRCodeComponent from 'vue-qrcode-component'
import vueDebounce from 'vue-debounce'
import bondinsurer from "@/bondinsurerConstants";
import authService from "@/authService";
import config from "@/config";
import wysiwyg from "vue-wysiwyg";
import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'
const pluginOptions = {
  /* see config reference */
  globalOptions: {  locale: 'en-US',
                    currency: null,
                    valueAsInteger: false,
                    distractionFree: {hideCurrencySymbol:true},
                    allowNegative: false 
                  }
}
// register globally
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.component('multiselect', Multiselect)
Vue.use(VueRouter,Bootstrap)
Vue.config.productionTip = false
Vue.use(PaginationPlugin)
Vue.component('b-collapse', BCollapse)
Vue.component('qr-code', VueQRCodeComponent)
// Vue.component('b-card', BCard)
// Vue.component('b-card-header', BCardHeader)
// Vue.component('b-card-text', BCardText)
// Vue.component('b-button', BButton)
// Vue.component('b-card-body', BCardBody)
Vue.directive('b-toggle', VBToggle)
Vue.directive('b-tooltip', VBTooltip)
Vue.component('b-tooltip', BTooltip)
Vue.component('b-button', BButton)
Vue.component('b-toast', BToast)
Vue.component('b-tabs', BTabs)
Vue.component('b-tab', BTab)
Vue.use(wysiwyg, {});


Vue.use(VueSimpleAlert)
Vue.use(VueCurrencyInput, pluginOptions)
Vue.use(Vue2Filters)
Vue.use(Notifications)
Vue.use(ToggleButton)
Vue.use(vueDebounce)
Vue.use(VueTour)
// Vue.use(moment)
Vue.prototype.moment = moment;
Vue.prototype.moment_timezone = moment_timezone;
Vue.prototype.$http = axios;
Vue.prototype.appMessages = appMessages;
Vue.prototype.$messaging = firebaseMessaging || null

window.$ = JQuery;
window.Chart = Chart;
window.sweetalert = VueSimpleAlert;
//GLOBAL VARIABLES
Vue.prototype.isDev = window.location.host !== 'www.drlgroup.app';
//GLOBAL METHODS
Vue.mixin({
  methods: {
     getRowColor(color){
      switch (color) {
        case 'DARK_GREEN':
          return 'row-dark-green'
        case 'LIGHT_GREEN':
          return 'row-light-green'
        case 'DARK_BLUE':
          return 'row-dark-blue'
        case 'LIGHT_BLUE':
          return 'row-light-blue'
        case 'PINK':
          return 'row-pink'
        case 'YELLOW':
          return 'row-orange'  
        default:
          return ''
      }
    },
    isUploadInProgress() {
      return localStorage.getItem("INVUPLOADSTATUS") === 'INPROGRESS';
    },
    getPLRemapStatus(){
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
     return this.$http
      .get(
        config.baseUrlAutoBidder +
          "/pnl/remap-status",
          auth
      )
    },
    getAbbreviation(bond_insurer) {
      const data = bondinsurer;
      for (const item of data) {
        if (item.bond_insurer === bond_insurer) {
          if( bond_insurer === 'FIREMEN_S_INS_OF_NEWARK/CONTL_CAS_INS'){
            return "FIREMEN'S INS OF NEWARK/CONTL CAS INS";
          }
          else{
            return item.Abbreviation;
          }
        }
      }
      return bond_insurer;
    },
    getYestedayDate(){
      var currentDate = new Date();
      var yesterdayDate = currentDate.setDate(currentDate.getDate()- 1);
      return new Date(yesterdayDate);
    },
    isAlphanumeric(e){
      var inputValue = String.fromCharCode(e.keyCode);
      var letterNumber = /^[0-9a-zA-Z]+$/;
      if((inputValue.match(letterNumber))) return true;
      else e.preventDefault();
    },
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isQuantity: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      }
      if(!(evt.charCode >= 48 && evt.charCode <= 57)){
        evt.preventDefault();
      }else{
        return true;
      }
    },
    convertMinutesToHours: function(totalMinutes){
      if(totalMinutes){
        var hours = Math.floor(totalMinutes / 60);          
        var minutes = totalMinutes % 60;
        return hours + ":" + minutes;
      }
      else{
        return "N/A"
      }
    },
    showSessionReloadPoup : function(){
      this.$fire({
        text: "Your session has expired. Please reload the page",
        confirmButtonText: 'Reload'
        }).then(() => {
            window.location.reload()
        })
    },
    formatNumber(number) {
      // Use toLocaleString to format the number with commas
      return number ? number.toLocaleString() : "";
    },
    convertToPercentage(decimalNumber) {
      if(decimalNumber == 0) return "0%"
      return (decimalNumber * 100).toFixed(2) + "%";
    }
   }
})
//Global Pipes
Vue.filter('currency', function (value) {
  if (value === null || value === undefined || value === '') return '$0.00'

  return '$' + new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value)
})
var filter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};
Vue.filter('truncate', filter);

router.afterEach((to) => {
  // Remove previously added class
  document.body.classList.remove('clientBody')

  // Add only for routes starting with /client
  if (to.path.startsWith('/client') || to.path.startsWith('/public-bid') || to.path.startsWith('/public-buy')) {
    document.body.classList.add('clientBody')
  }
})

new Vue({
  router,
  cognitoAuth,
  render: h => h(App),
}).$mount('#app')
